<template>
    <div class="commute">
                 
        <RadioGroup
            v-model="commute_dist_type"
            name="commute_dist_type"
            :change="notify_parent()"
            :div_classes=bootstrap_div_classes
            :default_val="commute_dist_type" :items=commute_dist_calc_types />   
        
        <br /><br />
        
        <div v-if="commute_dist_type == 'addresses'" id="mapcontainer">
            <BgMap :src="$data._mapcontainersrc" />
        </div>
        
        <div v-if="commute_dist_type == 'addresses'"  id="addresses">
            <div v-for="a in addresses"
                :key="a.name">
                <div v-if="a['formatted_address'] != ''">
                    <div>
                        <h2>
                        {{ address_labels[a.name] }}
                        </h2>
                            <hr />
                        <h3>
                        {{ a.formatted_address}} &nbsp; &nbsp; <button  class="green" @click="clearaddress(a.name)">{{ $t('commute.button.changeaddress') }}</button></h3>
                        
                    </div>
                </div>
                <div v-if="a['formatted_address'] == ''" >
                    <h2>
                    {{ address_labels[a.name] }}
                    </h2>
                    <vue-google-autocomplete
                        :ref="location_id_slug+a.name"
                        :id="location_id_slug+a.name"
                        classname="form-control"
                        :bounds="get_search_bounds(a.name)"
                        :placeholder="$t('commute.placeholder.enter-address')"
                        v-on:placechanged="get_address_data"
                        >
                        </vue-google-autocomplete>
                
                </div>
            </div>
            <div class="gauge" v-if="dist_gauge != ''" >
            <br>
                <img class="float_left" src="icons/map_100.png" style="height: 80px; opacity: 0.7; margin-right: 1em" >
                <ul>
                <li><strong>{{ $t('commute.dist_gauge.label') }} {{ dist_gauge }}</strong></li>
                <li><strong>{{ $t('commute.duration_gauge.label') }}  {{ duration_gauge }} <span v-if="vehicle_movement_type === 'driving'"  >
                {{  $t('commute.duration.depending-on-traffic') }}
                
                 </span></strong>
                </li>
                <li><strong> {{ $t('commute.average_speed') }}
                <VehicleSpeed
                :vehicle=vehicle
                :dist="commute_dist"
                :duration=commute_duration*60
                :duration_in_traffic=commute_duration_in_traffic*60  />
                
                <img v-if="vehicle_movement_type === 'driving'" v-tooltip="$t('commute.duration.variable-avg-speed-info')" height="16" src="icons/huh_18.png">
                </strong>
                </li>
                </ul>
            </div>
        </div>
            
            <div class="commute_">
                <div v-if="commute_dist_type === 'dist_daily'">
                    &nbsp; &nbsp;
                    <ConvertedNumber
                    v-on:input="commute_dist_daily = $event*2"  
                    :default_value="parseFloat(commute_dist_daily)/2"
                    classes="money"
                    :min=1 :max=500 :step=0.1
                    :display_conversion="display_function('distance')"
                    :store_conversion="store_function('distance')"
                    /> 
    
                    {{ $t('commute-dist-types.commute-dist-daily', {unit_distance: unit_distance}) }}
                    &nbsp; 
                    (≃ {{ convert('formatDistance', commute_dist_daily) }} {{ $t('per_day_commuted') }})
                    
                </div>
                <div v-if="commute_dist_type === 'dist_monthly'" >
                    &nbsp; &nbsp;
                    <ConvertedNumber
                    v-on:input="commute_dist_monthly = $event"  
                    :default_value="parseFloat(commute_dist_monthly)" 
                    :min=1 :max=5000
                    
                    classes="money"
                    :display_conversion="display_function('distance')"
                    :store_conversion="store_function('distance')"
                    /> 
                    {{ $t('commute-dist-types.commute-dist-monthly', {unit_distance: unit_distance}) }} 
                </div>
            </div>

            <div v-if="['dist_daily', 'dist_monthly'].includes(commute_dist_type)"> 
            <h3>
            {{ $t('commute.title.duration') }}
            </h3>
            
               &nbsp; &nbsp;
               <ConvertedNumber
                    v-on:input="commute_duration = $event"  
                    :default_value="parseFloat(commute_duration)" 
                    :min=1 :max=500
                    classes="money"
                    :display_conversion="half"
                    :store_conversion="double"
                    />
                    
                {{ $t('units.time.minutes') }} (≃ {{ convert('formatDuration', commute_duration*60) }} {{ $t('per_day_commuted') }} )
                
                <br/><br/>
                <div>
                 ({{ $t('commute.average_speed') }}

                <VehicleSpeed
                :tooltip=false
                :vehicle=vehicle
                :dist="commute_dist"
                :duration=commute_duration*60 />
                
                )
                </div>
                
            </div>
    </div>    
</template>

<script>
import RadioGroup from './RadioGroup.vue'
import RadioGroupPills from './RadioGroupPills.vue'
import VehicleSpeed from './VehicleSpeed.vue'
import BgMap from './BgMap.vue'
import ConvertedNumber from './ConvertedNumber.vue'
import conversions from '../conversions.js'
import settings from '../settings.js'

import Persistent from '../mixins/Persistent.js'

import VueGoogleAutocomplete from './VueGoogleAutocomplete.vue'

 
export default {
    components: {
        RadioGroup, RadioGroupPills, ConvertedNumber, VueGoogleAutocomplete, BgMap, VehicleSpeed
    },
    mixins: [Persistent],
    data: function(){
        return {
            traveltimes : {},
            addresses : [
            {
                name: "home",
                formatted_address : ""
            },{
                name: "work",
                formatted_address : ""

            }
            ],
            _mapcontainersrc : "",
            commute_dist_type : "",
            commute_dist_monthly : 1000,
            commute_dist_daily : 33,
            commute_duration : 120,
            commute_duration_in_traffic: NaN,
            commute_dist : 0,
            data_complete: false

        }
    },
    mounted() {
        // yes you have to pass the default value back up to the parent
        this.set_mapcontainersrc();
        this.get_commute_dist()
        this.get_commute_duration()
        this.notify_parent();
    },
    props: {
        this_commute_number : {
          type: [Number, String],
          default: 1
        },
        vehicle_speed_floor : {
            type: [Number, String],
            default: 5
        },
        vehicle_speed_ceiling : {
            type: [Number, String],
            default: 100
        },
        vehicle_movement_type : {
          type: String,
          default: "driving"
        },
        
    },
    computed : {
        vehicle : function(){
            return {
                speed_floor : this.vehicle_speed_floor,
                speed_ceiling : this.vehicle_speed_ceiling,
            }
        },
    
        dist_gauge : function(){
            let v = this.get_commute_dist()
            if(v > 0){
                return conversions.formatDistance(v)
            } 
            return ""
        },
        duration_gauge : function(){
            let v = this.get_commute_duration()
            if(v > 0){
                v -= v % 60 // round to nearest minute
                if(this.vehicle_movement_type == 'driving'){
                    let dit = 0
                    if(this.traveltimes['DRIVING']['duration_in_traffic']){
                        dit = this.traveltimes['DRIVING']['duration_in_traffic']
                    }
                    if(dit > 0){
                        dit -= dit % 60 // round to nearest minute
                        return conversions.formatDurationRange([v,dit])
                    } else {
                        return conversions.formatDuration(v)
                    }
                } else {
                    return conversions.formatDuration(v)
                }
            } 
            
            return ""
        },
        location_id_slug : function(){
            
            return "LOCATION"+this.this_commute_number+"_"
        },
        address_labels : function(){
            return {
                home : this.$t('commute.addresslabels.home'),
                work : this.$t('commute.addresslabels.work')
            }
        },
        unit_distance : function(){
            return settings.getDistanceUnit();
        },
        bootstrap_div_classes : function(){
            return "dbtn-group dbtn-group-toggle"
        },
        commute_freq_types : function(){
            return [
                {label: this.$t('commute-freq-types.regularly'), value : 'days_per_week'}, 
                {label: this.$t('commute-freq-types.varies'), value : 'days_per_month'}
            ]                 
        },
        commute_dist_calc_types : function(){
            return [
             {label: this.$t('commute-dist-types.addresses'), value : 'addresses'},
             {label: this.$t('commute-dist-types.dist_daily'), value : 'dist_daily'},
             {label: this.$t('commute-dist-types.dist_monthly'), value : 'dist_monthly'}
            ]
        }
    },
    watch : {
        init_data : function(){
            for (let k in this.init_data){
                this.$data[k] = this.init_data[k];
            }
        },
        commute_dist_type : function(){
            this.get_commute_dist()
        },
        commute_dist_daily : function(){
            this.get_commute_dist()
        },
        commute_dist_monthly : function(){
            this.get_commute_dist()
        }
    },
    methods: {
        commute_speed : function(d,t){ //dist in m, time in minutes
            return (parseFloat(d)/1000) / (parseFloat(t) / 60) // kph
        },
        corrected_commute_duration(d,t){ //dist in m, time in minutes
            let s = this.commute_speed(d,t)
            //console.log('corrected_commute_duration d='+d)
            //console.log('corrected_commute_duration t='+t)
            //console.log('corrected_commute_duration s='+s)
            //console.log('corrected_commute_duration vehicle_speed_floor='+this.vehicle_speed_floor)
            //console.log('corrected_commute_duration vehicle_speed_ceiling='+this.vehicle_speed_ceiling)
            
            if(s < this.vehicle_speed_floor){ //vehicle_speed_floor  in kph
                // too slow, return max time in minutes
                return (d / (this.vehicle_speed_floor * 1000)) * 60
            }
            if(s > this.vehicle_speed_ceiling){
                // too fast, return min time in minutes
                return (d / (this.vehicle_speed_ceiling * 1000)) * 60

            }
            return t // acceptable duration
        },
        get_commute_dist : function(){
            if(this.commute_dist_type == 'dist_daily'){
                this.commute_dist = this.commute_dist_daily
            } else if(this.commute_dist_type == 'dist_monthly'){
                this.commute_dist = parseFloat(this.commute_dist_monthly / (365.25/12));
            } else if(this.commute_dist_type === 'addresses'){
                let t = this.vehicle_movement_type
                let di = 0 // distance
                
                if(t === "bicycling"){
                    t = "walking" // use walking dist
                }
                
                try {
                
                    if(this.traveltimes[t.toUpperCase()]['distance'] > 0){
                        di = parseFloat(this.traveltimes[t.toUpperCase()]['distance']) / 1000 
                    }
                } catch(err){}
                
                //console.log('get_commute_dist')
                this.commute_dist = di * 2 //  assume return home same distance as going to work
                
                return di // in km
            }
        },
        get_commute_duration : function(){
            this.commute_duration_in_traffic = NaN
            if(this.commute_dist_type === 'addresses'){
                let t = this.vehicle_movement_type
                let du = 0 // distance
                let dit = NaN // duration in traffic
                
                if(t === "bicycling"){
                    t = "walking" // use walking dist
                }
                try {
                    if(this.traveltimes[t.toUpperCase()]['duration'] > 0){
                        du = parseFloat(this.traveltimes[t.toUpperCase()]['duration'])
                        dit = parseFloat(this.traveltimes[t.toUpperCase()]['duration_in_traffic'] ? this.traveltimes[t.toUpperCase()]['duration_in_traffic'] : NaN)
                    }


                    let dist = this.get_commute_dist()

                    //console.log('get_commute_duration t='+t)
                    //console.log('get_commute_duration du='+du)
                    //console.log('get_commute_dist dist='+dist)
                    
                    du = this.corrected_commute_duration(parseFloat(dist)*1000, parseFloat(du)/60) * 60
                    //console.log('corrected_commute_duration du='+du)
                    
                    
                    
                } catch(err){ }
                
                this.commute_duration_in_traffic = (dit / 60) * 2
                this.commute_duration = (du / 60) * 2 //  assume return home same duration as going to work
                return du
            }
            return 0
        },
        set_mapcontainersrc : function(){
            let lat = this.addresses[0]['latitude']
            let lon = this.addresses[0]['longitude']
            let zoom = 10
            
            if(lat == undefined){
                zoom = 2
                lat = (Math.random() * (-60 - 60) + 60).toFixed(4)
                lon = (Math.random() * (-130 - 160) + 160).toFixed(4)
            }
            
            this.$data._mapcontainersrc = "bgmap.html#zoom="+zoom+"&lat="+ lat + "&lon="+ lon;
            //console.log(this.mapcontainersrc)
        },
        clearaddress : function(name){
            for(let l in this.addresses){
                if(this.addresses[l]['name'] == name){
                    this.$set(this.addresses, l,  {
                        name : name,
                        formatted_address : ""

                    })
                    
                    break;
                }
            }
        },
        get_search_bounds : function(forwhom){
            if(forwhom == "home"){
                return null;
            }
            let home_filled = false;
            for(let l in this.addresses){
                if(this.addresses[l]['name'] == "home" && this.addresses[l]['formatted_address'] != ""){
                    return {
                        lat: this.addresses[l]['latitude'],
                        lng: this.addresses[l]['longitude'],
                        radius: 75000
                    }
                }
            }
            
            return null
        },
        all_addresses_filled : function(){
            let filled = 0
            for(let l in this.addresses){
                if(this.addresses[l]['formatted_address'] != ""){
                    filled++
                }
            }
            if(filled == this.addresses.length){
                return true
            }
            return false
        },
        notify_parent : function(){
            this.data_complete = false
            if(this.commute_dist > 0){
                this.data_complete = true
            }
            
            
            this.save_data()
            
        },
        
        convert: function(fn, ...args){
            return conversions[fn](...args);
        },
        
        get_address_data: function (addressData, placeResultData, id) {

            let keepers = 'address_components,formatted_address,utc_offset'.split(',')
            
            let d = {};
            
            for(let keep in keepers){
                d[keepers[keep]] = placeResultData[keepers[keep]]
            }
            
            d['latitude'] = addressData['latitude']
            d['longitude'] = addressData['longitude']

            //console.log(placeResultData)
            //console.log(d)
            //console.log(this.addresses)
            //console.log(id)                
            
            for(let a in this.addresses){
                if(this.location_id_slug+this.addresses[a]['name'] == id){
                    d['name'] = this.addresses[a]['name']
                    this.$set(this.addresses, a, d)
                }
            }

            this.notify_parent()
            
            if(this.all_addresses_filled()){
                this.getDistanceTime();
            }
            this.set_mapcontainersrc()
            
        },
        
        getDistanceTime: function(){
            let origins = []
            let destinations = []
            let utc_offset = 0
      
            for(let a in this.addresses){
                utc_offset = this.addresses[a]['utc_offset']
                switch(this.addresses[a]['name']){
                    case 'home' :
                        origins.push(this.addresses[a]['latitude']+","+this.addresses[a]['longitude'])
                        break;
                    case 'work' : 
                        destinations.push(this.addresses[a]['latitude']+","+this.addresses[a]['longitude'])
                        break;
                }                   
            }
            
            // simplify lat/lng to nearest ~10m for key
            var modes = ["DRIVING", "TRANSIT", "WALKING"]

            let traveltimes_key = parseFloat(this.addresses[0]['latitude']).toFixed(3)
            traveltimes_key += ","+parseFloat(this.addresses[0]['longitude']).toFixed(3)
            traveltimes_key += "|"
            traveltimes_key += parseFloat(this.addresses[1]['latitude']).toFixed(3)
            traveltimes_key += ","+parseFloat(this.addresses[1]['longitude']).toFixed(3)
            
            if(traveltimes_key === this.traveltimes['key']){
               return
            }
            this.traveltimes = {
                "key" : traveltimes_key
            }
            
            let d = new Date(Date.now()); // UTC now
            d.setDate(d.getDate() + ((7-d.getDay())%7+9) % 7);
            d.setDate(d.getDate() + 7);
            d.setHours(8,-utc_offset,0,0); // 8am local

            // d is next tuesday morning at 8am local time at position's timezone

            for(let m in modes){
                var vm = this;

                let distanceService = new google.maps.DistanceMatrixService();

                distanceService.getDistanceMatrix({
                    origins: origins,
                    destinations: destinations,
                    travelMode: modes[m],
                    unitSystem: google.maps.UnitSystem.METRIC,
                    avoidHighways: false,
                    avoidTolls: false,
                    drivingOptions : {departureTime : d, trafficModel: 'pessimistic'}
                },
                function (response, status) {
                    if (status !== google.maps.DistanceMatrixStatus.OK) {
                        //console.log('Error:', status);
                    } else {
                        let res = {
                            distance : -1,
                            duration: -1,
                            status: 'KO'
                        }
                        //console.log(modes[m])
                        //console.log(response['rows'])
                        for(let r in response['rows']){
                            for(let e in response['rows'][r]['elements']){
                                if(response['rows'][r]['elements'][e]['status'] == 'OK'){
                                    if(res['duration'] == -1 || response['rows'][r]['elements'][e]['duration'] < res['duration']){
                                        res['duration'] = response['rows'][r]['elements'][e]['duration']['value']; // in seconds
                                        res['distance'] = response['rows'][r]['elements'][e]['distance']['value']; // in meters
                                        if(response['rows'][r]['elements'][e]['duration_in_traffic']){
                                            res['duration_in_traffic'] = response['rows'][r]['elements'][e]['duration_in_traffic']['value']
                                        }
                                        res['status'] = 'OK';
                                    }
                                }
                            }
                        }
                        
                        vm.$set(vm.traveltimes, modes[m], res);
                        vm.get_commute_dist()
                        vm.get_commute_duration()
        
                        //console.log(response)
                    }
                });
            }

        },
        
        half: function(v){
            return v/2
        },
        
        double: function(v){
            return v*2
        },
        
        settings : function(fn, ...args){
            return settings[fn](...args);
        },
        
        display_function: function(t){
            let unit;
            switch(t) {
                case 'distance':
                    unit = settings.getDistanceUnit();
                    if(unit == 'km'){
                        return function(d){return d}
                    }
                    return conversions['km2'+unit];
                break;

                case 'volume':
                    unit = settings.getVolumeUnit();
                    if(unit == 'l'){
                        return function(d){return d}
                    }
                    return conversions['l2'+unit];
            }
        },
        store_function: function(t){
            let unit;
            switch(t) {
                case 'distance':
                    unit = settings.getDistanceUnit();
                    if(unit == 'km'){
                        return function(d){return d}
                    }
                    return conversions[unit+'2km']
                break;
                case 'volume':
                    unit = settings.getVolumeUnit();
                    if(unit == 'l'){
                        return function(d){return d}
                    }
                    return conversions[unit+'2l']
            }
        }
    }
}
    

</script>

<style>
div.commute_freq_type {
    width: 400px;
}

div.commute_freq_type > div {
    padding: .2em;
    border-radius: .2em;
}

#addresses input {
    height: 2em;
    padding: 0.5em;
    width: 95%;
    text-align: left;
}

#addresses h2, 
#addresses h3 {
    text-shadow: 1px 1px #fff, 2px 2px rgba(255,255,255,0.6)
} 

/*
#addresses {
    margin-top: -28em;
    position: relative;
    height: 24em;
    padding: 2em;
}
*/

#addresses {
    margin-top: -27em;
    position: relative;
    height: 23em;
    padding: 2em;
}
div#mapcontainer {
    width: 100%;
    border-top: 17em;
    margin-right: 3em;
    border: 0;
    height: 25em;
    opacity: 0.5;
    border-radius: 20px;
    border: 1px solid #fff;
}
/*
div#mapcontainer {
    width: 100%;
    border-top: 17em;
    margin-right: 3em;
    border: 0;
    height: 26em;
    opacity: 0.5;
    border-radius: 20px;
    border: 1px solid #fff;
    
}
*/
div#mapcontainer iframe {
    border: 0;
    border-radius: 20px;
    z-index: -1;
    height: 100%;
    width:  100%;
    filter: blur(3px);
}
</style>